export default __webpack_public_path__ + "static/media/icon-Motif de la consultation.370703a6.svg";